/** Uygulama menü ve route guard rolleri (backend ile uyumlu) */
export const APP_ROLE = {
  ADMIN: 'Admin',
  USERS: 'Kullanici',
  ANNOUNCEMENTS: 'Duyuru',
  MEMBERS: 'Uyeler',
  CONTENT: 'Icerik',
  PROJECTS: 'Projeler',
  NOTIFICATIONS: 'Bildirimler',
  EVENTS: 'Etkinlik',
  SURVEYS: 'Anket',
  /** Ödemeler modülü — API dokümantasyonunda "Ödeme" */
  PAYMENTS: 'Odeme',
};

/** Ödeme modülü erişimi: ASCII ve Türkçe karakterli rol adları */
export const PAYMENTS_ROLE_ALIASES = [APP_ROLE.PAYMENTS, 'Ödeme'];

/**
 * @param {(role: string) => boolean} hasRole
 * @param {string[]} roleNames
 */
export const hasAnyOfRoles = (hasRole, roleNames) => {
  if (hasRole(APP_ROLE.ADMIN)) return true;
  return roleNames.some((name) => hasRole(name));
};

/**
 * Sidebar / menü öğesi için rol kontrolü
 * @param {(role: string) => boolean} hasRole
 * @param {string | null} requiredRole
 */
export const canAccessRole = (hasRole, requiredRole) => {
  if (hasRole(APP_ROLE.ADMIN)) return true;
  if (!requiredRole) return true;
  if (requiredRole === APP_ROLE.PAYMENTS) {
    return hasAnyOfRoles(hasRole, PAYMENTS_ROLE_ALIASES);
  }
  return hasRole(requiredRole);
};

export const canAccessPayments = (hasRole) => canAccessRole(hasRole, APP_ROLE.PAYMENTS);
